"use strict";

var _typeof = require("/builds/bright-technologies/inocrowd/inocrowd-website/frontend/node_modules/@babel/runtime/helpers/typeof");

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var Drift = function (_super) {
  __extends(Drift, _super);

  function Drift() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Drift.prototype.componentDidMount = function () {
    var _a = this.props,
        appId = _a.appId,
        attributes = _a.attributes,
        config = _a.config,
        userId = _a.userId;

    if ((typeof window === "undefined" ? "undefined" : _typeof(window)) !== undefined) {
      var script = document.createElement('script');
      script.async = true;
      script.innerText = "\n                \"use strict\";\n\n                !function() {\n                    var t = window.driftt = window.drift = window.driftt || [];\n                    if (!t.init) {\n                        if (t.invoked) return void (window.console && console.error && console.error(\"Drift snippet included twice.\"));\n                        t.invoked = !0, t.methods = [ \"identify\", \"config\", \"track\", \"reset\", \"debug\", \"show\", \"ping\", \"page\", \"hide\", \"off\", \"on\" ],\n                        t.factory = function(e) {\n                            return function() {\n                                var n = Array.prototype.slice.call(arguments);\n                                return n.unshift(e), t.push(n), t;\n                            };\n                        }, t.methods.forEach(function(e) {\n                            t[e] = t.factory(e);\n                        }), t.load = function(t) {\n                            var e = 3e5, n = Math.ceil(new Date() / e) * e, o = document.createElement(\"script\");\n                            o.type = \"text/javascript\", o.async = !0, o.crossorigin = \"anonymous\", o.src = \"https://js.driftt.com/include/\" + n + \"/\" + t + \".js\";\n                            var i = document.getElementsByTagName(\"script\")[0];\n                            i.parentNode.insertBefore(o, i);\n                        };\n                    }\n                }();\n\n                drift.SNIPPET_VERSION = '0.3.1';\n                drift.load(\"" + appId + "\");\n            ";
      document.body.appendChild(script);
    }
  };

  Drift.prototype.render = function () {
    return null;
  };

  return Drift;
}(React.Component);

exports.Drift = Drift;